import api from '../../API';
import { IntegrationType, ServiceAccount } from '../../types';

export default {
  async findAll(accountId: number): Promise<ServiceAccount[]> {
    const response = await api.get(`accounts/${accountId}/service-accounts`);
    return response.data;
  },
  async findByIntegrationType(
    accountId: number,
    integrationType: IntegrationType,
  ): Promise<ServiceAccount|undefined> {
    const serviceAccounts = await this.findAll(accountId);
    return serviceAccounts.find(sa => sa.integrationType === integrationType);
  },
};
